var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 6 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.5 1L4.81534 10.5896C4.93277 10.8506 4.93277 11.1494 4.81534 11.4104L0.5 21","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }